import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Reception } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getReceptions = createAsyncThunk<
  Reception[],
  string,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_RECEPTIONS, async (businessDate, { extra }) => {
  return await extra.batchesRepo.getReceptions(businessDate);
});
